import { Status } from '../type';

export const getStatus = (status?: Status) =>
	({
		active: 'Activo',
		inactive: 'Inactivo',
	}[status || 'active']);

export const getStatusColor = (status?: Status) =>
	({
		active: '#8DC63F',
		inactive: '#C22A58',
	}[status || 'active']);
